import styled from 'styled-components';
import PropTypes from 'prop-types';
import { nuDSColor } from '@nubank/nuds-web/styles/themeUtils';

export const Path = styled.path`
  fill: ${({ variant }) => nuDSColor(variant)};
`;

Path.displayName = 'BasePath';

Path.propTypes = {
  variant: PropTypes.string.isRequired,
};
